import axios from "axios";
//////////////////////////////////////////////////////////////////////////////
export const getProduct = () => async (dispatch, getState) => {
  dispatch({
    type: "loadingProduct",
    payload: { data: [], loading: true, error: "" },
  });
  try {
    const { data } = await axios.get("http://kzico.runflare.run/product/");
    dispatch({
      type: "successProduct",
      payload: { data: data, loading: false, error: "" },
    });
  } catch (error) {
    dispatch({
      type: "failedProduct",
      payload: { data: [], loading: false, error: error.message },
    });
  }
};
//////////////////////////////////////////////////////////////////////////////
export const getProfile = () => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("User")).token;
  dispatch({
    type: "loadingProfile",
    payload: { data: [], loading: true, error: "" },
  });
  try {
    const { data } = await axios.get("http://kzico.runflare.run/user/profile", {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    localStorage.setItem("User", JSON.stringify(data.user));
    dispatch({
      type: "successProfile",
      payload: { data: data, loading: false, error: "" },
    });
  } catch (error) {
    dispatch({
      type: "failedProfile",
      payload: { data: [], loading: false, error: error.message },
    });
  }
};
///////////////////////////////////////////////////////////////////////////////
export const getIdPrduct = (product) => async (dispatch) => {
  dispatch({
    type: "loadingIdPrduct",
    payload: { data: [], loading: true, error: "" },
  });
  try {
    const { data } = await axios.get(
      `http://kzico.runflare.run/product/${product}`
    );
    dispatch({
      type: "successIdPrduct",
      payload: { data: data, loading: false, error: "" },
    });
  } catch (error) {
    dispatch({
      type: "failedIdPrduct",
      payload: { data: [], loading: false, error: error.message },
    });
  }
};
////////////////////////////////////////////////////////////////////////////////
export const getCart = (type, product, data) => (dispatch, getState) => {
  const cart = getState().Cart;

  if (type === "AddProduct") {
    const help = JSON.parse(JSON.stringify(data));
    help.qty = 1;
    let finaldata = [...cart, help];
    if (cart.length === 0) {
      localStorage.setItem("orderArray", JSON.stringify(finaldata));
      dispatch({
        type: type,
        payload: finaldata,
      });
    } else {
      cart.push(finaldata);
      localStorage.setItem("orderArray", JSON.stringify(finaldata));
      dispatch({
        type: type,
        payload: finaldata,
      });
    }
  } else if (type === "PlusNumber") {
    cart.map((item, index) => {
      if (item._id === product) {
        cart[index].qty = cart[index].qty + 1;
        localStorage.setItem("orderArray", JSON.stringify(cart));
        dispatch({
          type: type,
          payload: cart,
        });
      }
    });
  } else if (type === "MinusNumber") {
    cart.map((item, index) => {
      if (item._id == product) {
        cart[index].qty = cart[index].qty - 1;
        localStorage.setItem("orderArray", JSON.stringify(cart));
        dispatch({
          type: type,
          payload: cart,
        });
        if (cart[index].qty === 0) {
          cart.splice(index, 1);
          localStorage.setItem("orderArray", JSON.stringify(cart));
          dispatch({
            type: type,
            payload: cart,
          });
        }
      }
    });
  }
};
//////////////////////////////////////////////////////////////////////////////
export const getCheckout = (orderItems, FinalOrder) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("User")).token;
  dispatch({
    type: "loadingCheckout",
    payload: { data: [], loading: true, error: "" },
  });
  try {
    const { data } = await axios.post(
      "http://kzico.runflare.run/order/submit",
      {
        orderItems: orderItems,
        shippingAddress: {
          address: FinalOrder.address,
          city: FinalOrder.city,
          postalCode: FinalOrder.postalCode,
          phone: FinalOrder.phone,
        },
        paymentMethod: FinalOrder.paymentMethod,
        shippingPrice: FinalOrder.shippingPrice,
        totalPrice: FinalOrder.totalPrice,
      },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: "successCheckout",
      payload: { data: data, loading: false, error: "" },
    });
  } catch (error) {
    dispatch({
      type: "failedCheckout",
      payload: { data: [], loading: false, error: error.message },
    });
  }
};
//////////////////////////////////////////////////////////////////////////////
export const getOrders = () => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("User")).token;
  dispatch({
    type: "loadingOrders",
    payload: { data: [], loading: true, error: "" },
  });
  try {
    const { data } = await axios.get("http://kzico.runflare.run/order/", {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: "successOrders",
      payload: { data: data, loading: false, error: "" },
    });
  } catch (error) {
    dispatch({
      type: "failedOrders",
      payload: { data: [], loading: false, error: error.message },
    });
  }
};
//////////////////////////////////////////////////////////////////////////////
export const getOrderId = (id) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("User")).token;
  dispatch({
    type: "loadingOrderId",
    payload: { data: {}, loading: true, error: "" },
  });
  try {
    const { data } = await axios.get(`http://kzico.runflare.run/order/${id}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: "successOrderId",
      payload: { data: data, loading: false, error: "" },
    });
  } catch (error) {
    dispatch({
      type: "failedOrderId",
      payload: { data: {}, loading: false, error: error.message },
    });
  }
};
//////////////////////////////////////////////////////////////////////////////
export const getChangeProfile = (Profileing) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("User")).token;
  dispatch({
    type: "loadingChangeProfile",
    payload: { data: [], loading: true, error: "" },
  });
  try {
    const { data } = await axios.put(
      "http://kzico.runflare.run/user/change-profile",
      {
        firstname: Profileing.FirstName,
        lastname: Profileing.LastName,
        gender: Profileing.Gender,
        age: Profileing.Age,
        city: Profileing.City,
      },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: "successChangeProfile",
      payload: { data: data, loading: false, error: "" },
    });
  } catch (error) {
    dispatch({
      type: "failedChangeProfile",
      payload: { data: [], loading: false, error: error.message },
    });
  }
};
//////////////////////////////////////////////////////////////////////////////
export const getUploadAvatar = (Pic) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("User")).token;
  dispatch({
    type: "loadingUploadAvatar",
    payload: { data: [], loading: true, error: "" },
  });
  try {
    const formData = new FormData();
    formData.append("profile-image", Pic);
    const { data } = await axios.post(
      "http://kzico.runflare.run/user/profile-image",
      formData,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: "successUploadAvatar",
      payload: { data: data, loading: false, error: "" },
    });
  } catch (error) {
    dispatch({
      type: "failedUploadAvatar",
      payload: { data: [], loading: false, error: error.message },
    });
  }
};
//////////////////////////////////////////////////////////////////////////////
export const getChangePassword = (OldPass, NewPass) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("User")).token;
  dispatch({
    type: "loadingChangePassword",
    payload: { data: [], loading: true, error: "" },
  });
  try {
    const { data } = await axios.put(
      "http://kzico.runflare.run/user/change-password",
      {
        old_password: OldPass,
        new_password: NewPass,
      },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: "successChangePassword",
      payload: { data: data, loading: false, error: "" },
    });
  } catch (error) {
    dispatch({
      type: "failedChangePassword",
      payload: { data: [], loading: false, error: error.message },
    });
  }
};
//////////////////////////////////////////////////////////////////////////////
export const getSingUp =
  (UserName, Email, Password, Mobile) => async (dispatch) => {
    dispatch({
      type: "loadingSingUp",
      payload: { data: [], loading: true, error: "" },
    });
    try {
      const { data } = await axios.post(
        "http://kzico.runflare.run/user/signup",
        {
          username: UserName,
          email: Email,
          password: Password,
          mobile: Mobile,
        }
      );
      dispatch({
        type: "successSingUp",
        payload: { data: data, loading: false, error: "" },
      });
    } catch (error) {
      dispatch({
        type: "failedSingUp",
        payload: { data: [], loading: false, error: error.message },
      });
    }
  };
//////////////////////////////////////////////////////////////////////////////
export const getLogin = (UserName, Password) => async (dispatch, getState) => {
  dispatch({
    type: "loadingLogin",
    payload: { data: {}, loading: false, error: "" },
  });
  try {
    const { data } = await axios.post("http://kzico.runflare.run/user/login", {
      email: UserName,
      password: Password,
    });
    dispatch({
      type: "successLogin",
      payload: { data: data.user, loading: false, error: "" },
    });
    localStorage.setItem("User", JSON.stringify(data.user));
  } catch (error) {
    dispatch({
      type: "failedLogin",
      payload: { data: {}, loading: false, error: error.message },
    });
  }
};
//////////////////////////////////////////////////////////////////////////////
export const getClear = () => async (dispatch, getState) => {
  const cart = getState().Cart;
  dispatch({
    type: "Clear",
    payload: [],
  });
};
